import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "flex-horizontal-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m12 11 2.5-2.5L12 6" }),
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeMiterlimit: 10, d: "M14 8.5H3" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
